import { useUpdateReceiptInformation } from '@/features/update-receipt-information'
import { Button } from '@/shared/ui'

type Props = {
  contractId: number
  onSuccess?: () => void
}

export const UpdateReceiptInformationButton = ({
  contractId,
  onSuccess,
}: Props) => {
  const { updateReceiptInformation } = useUpdateReceiptInformation({
    contractId,
    onSuccess,
  })

  const handleSaveButtonClick = async () => {
    await updateReceiptInformation()
  }

  return (
    <Button
      type="button"
      variant="solid"
      color="primary"
      size="large"
      fullWidth
      onClick={handleSaveButtonClick}
    >
      저장하기
    </Button>
  )
}
